export class Configuration {
    googleApiKey: string
    googleMapZoomLevel: number
    stationSearchRadius: number
    merchantId: string

    constructor(googleApiKey: string, googleMapZoomLevel: number, stationSearchRadius: number , merchantId: string) {        
        this.googleApiKey = googleApiKey
        this.googleMapZoomLevel = googleMapZoomLevel ? googleMapZoomLevel : 4
        this.stationSearchRadius = stationSearchRadius
        this.merchantId = merchantId
    }
}